import React, { useEffect } from 'react';
import { useIntl } from '@leagueplatform/locales';

import {
  Box,
  Button,
  HeadingText,
  Image,
  Modal,
  StackLayout,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { HEALTH_JOURNEY_COMMON_ASSET_KEYS } from '@leagueplatform/health-journey-common';
import { useProgramDetailsAnalytics } from '../hooks/use-program-details-analytics';

const modalTitleId = 'remove-program-modal-title';

interface RemoveProgramModalProps {
  onClose: () => {};
  requestLeaveHealthProgram: () => {};
  onProgramRemove: () => {};
  programName: string;
  programId: string;
}

export const RemoveProgramModal = ({
  onClose,
  requestLeaveHealthProgram,
  onProgramRemove,
  programName,
  programId,
}: RemoveProgramModalProps) => {
  const { formatMessage } = useIntl();
  const programDetailsAnalytics = useProgramDetailsAnalytics(
    programName,
    programId,
  );

  useEffect(() => {
    programDetailsAnalytics.viewProgramDetailsRemoveModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeActivityImage = useStaticAsset(
    HEALTH_JOURNEY_COMMON_ASSET_KEYS.REMOVE_PROGRAM_IMAGE,
  ) as string;

  return (
    <Modal.Root
      defaultOpen
      onOpenChange={(open) => {
        if (!open && onClose) {
          onClose();
        }
      }}
      aria-label={modalTitleId}
    >
      <Modal.Content layout="standard">
        <Modal.Title hidden>
          {formatMessage({ id: 'REMOVE_PROGRAM' })}
        </Modal.Title>
        <StackLayout
          css={{ padding: '$two' }}
          spacing="$one"
          orientation="vertical"
          horizontalAlignment="center"
        >
          <Image src={removeActivityImage} />
          <Box
            css={{
              width: '30ch',
              textAlign: 'center',
              paddingBottom: '$one',
            }}
          >
            <HeadingText size="xl" level="2">
              {formatMessage({ id: 'REMOVE_PROGRAM' })}
            </HeadingText>
          </Box>
          <Box
            css={{
              width: '30ch',
              textAlign: 'center',
              paddingBottom: '$one',
            }}
          >
            <UtilityText>
              {formatMessage({ id: 'ARE_YOU_SURE_REMOVE_PROGRAM' })}
            </UtilityText>
          </Box>
          <Button
            priority="primary"
            size="large"
            textAlign="start"
            type="button"
            width="fillContainer"
            destructive
            onClick={() => {
              requestLeaveHealthProgram();
              onProgramRemove();
            }}
          >
            {formatMessage({ id: 'REMOVE_PROGRAM_BUTTON' })}
          </Button>
          <Button
            priority="secondary"
            size="large"
            textAlign="start"
            type="button"
            width="fillContainer"
            onClick={() => {
              onClose();
            }}
          >
            {formatMessage({ id: 'CANCEL' })}
          </Button>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
};
